module.exports = __webpack_public_path__ + "static/IMC_logo_white_FR-fb8b639288cd1dce14fc22308f014f23.svg";